export interface JobEvaluation {
  id: string;
  controle_projeto_id?: string;
  freelancer_id?: string;
  agencia_id?: string;
  evaluator_type: 'agencia' | 'freelancer';
  status: 'pending' | 'email_sent' | 'rated' | 'completed';
  rating?: number;
  feedback?: string;
  rated_at?: string;
  created_at?: string;
  updated_at?: string;

  // Campos relacionados para exibição
  freelancer_name?: string;
  agencia_name?: string;
}

export interface JobEvaluationListItem {
  id: string;
  controle_projeto_id?: string;
  freelancer_id?: string;
  agencia_id?: string;
  evaluator_type: 'agency' | 'freelancer';
  status: 'pending' | 'email_sent' | 'rated' | 'completed';
  rating?: number;
  media_geral?: number;
  rated_at?: string;
  created_at?: string;
  feedback_text?: string;
  feedback_data?: FreelancerFeedbackDataV1 | FreelancerFeedbackDataV2 | AgencyFeedbackData | Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any

  // Campos relacionados para exibição
  freelancer_name?: string;
  agencia_name?: string;
  freelancer_email?: string;
  agencia_email?: string;
  project_start_date?: string;
  project_end_date?: string;
  project_nucleo?: string | null;
  numero_renovacoes?: number;
}

// Feedback data do formulário freelancer v1
export interface FreelancerFeedbackDataV1 {
  service_satisfaction_rating?: number;
  team_evaluation_rating?: number;
  corisco_satisfaction_rating?: number;
}

// Feedback data do formulário freelancer v2 (detalhado)
export interface FreelancerFeedbackDataV2 {
  gestao_geral_rating?: number;
  gestores_diretos_rating?: number;
  qualidade_feedbacks_rating?: number;
  espaco_plataformas_rating?: number;
  avaliacao_equipe_rating?: number;
  comunicacao_rh_financeiro_rating?: number;
  corisco_satisfaction_rating?: number;
}

// Feedback data do formulário de agência
export interface AgencyFeedbackData {
  freelancer_performance_rating?: number;
  freelancer_characteristics?: string[];
  corisco_satisfaction_rating?: number;
}

// Type guard para detectar feedback v2
export function isFeedbackDataV2(data: any): data is FreelancerFeedbackDataV2 { // eslint-disable-line @typescript-eslint/no-explicit-any
  return data && 'gestao_geral_rating' in data;
}

export interface JobEvaluationFilters {
  agencia_id?: string;
  freelancer_id?: string;
  status?: 'all' | 'preenchido' | 'nao_preenchido';
  evaluator_type?: 'agency' | 'freelancer' | '';
}

// Critérios de avaliação por usuário de agência
export const CRITERIOS_AVALIACAO_AGENCIA = [
  { slug: "tecnica_craft", label: "Técnica/Craft" },
  { slug: "criatividade", label: "Criatividade" },
  { slug: "versatilidade", label: "Versatilidade" },
  { slug: "proatividade", label: "Proatividade" },
  { slug: "comunicacao_comprometimento_pontualidade", label: "Comunicação, Comprometimento e Pontualidade" },
  { slug: "postura", label: "Postura" },
] as const;

export type CriterioSlug = typeof CRITERIOS_AVALIACAO_AGENCIA[number]["slug"];

export interface AvaliacaoUsuarioAgencia {
  id: string;
  job_evaluation_id: string;
  user_id: string;
  notas: Record<CriterioSlug, number>;
  comentario?: string;
  created_at: string;
  updated_at: string;
}

export interface AvaliadorInfo {
  user_id: string;
  full_name: string;
}

export interface AvaliacaoAgenciaListItem extends JobEvaluationListItem {
  minha_avaliacao?: AvaliacaoUsuarioAgencia | null;
  avaliadores?: AvaliadorInfo[];
}

export type FiltroAvaliacaoAgencia = "todas" | "avaliadas" | "nao_avaliadas";
